import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';
import { FirmNameCellRenderer } from './FirmNameCellRenderer';

export const firmNameColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'name',
  headerName: 'Firm Name',
  initialWidth: 325,
  cellRenderer: FirmNameCellRenderer,
  pinned: 'left',
};
